import { render, staticRenderFns } from "./DataBankSearch.vue?vue&type=template&id=5b0668d7&scoped=true&"
import script from "./DataBankSearch.vue?vue&type=script&lang=js&"
export * from "./DataBankSearch.vue?vue&type=script&lang=js&"
import style0 from "./DataBankSearch.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DataBankSearch.vue?vue&type=style&index=1&id=5b0668d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0668d7",
  null
  
)

export default component.exports